module.exports = __webpack_public_path__ + "static/media/image-7.829222ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-7.jpg
// module id = 262
// module chunks = 0